import * as React from "react";
import {cs} from "../../../../../../../../react/chain-services";
import "./list-view.scss";
import {MailingListDetailsTable} from "../../../../../mailing-list-details-table/mailing-list-details-table";

export const ListView = ({mailingListId, entityId}) => cs(
    ["mailingListDetailsTable", (_, next) => MailingListDetailsTable({
        mailingListId,
        entityId,
        xdQaNamePrefix: "CASS Result",
        next,
    })],
    ({mailingListDetailsTable}) => (
        <div className="list-view-4p4">
            <div className="header">
                <div className="left">

                    <div className="title" xd-qa-type="label" xd-qa-name="CASS Result File Preview">
                        File Preview
                    </div>
                    <div className="sub-title" xd-qa-type="label" xd-qa-name="CASS Result File Preview Description">
                        If the addresses appear to be correct, select “Finish”.
                    </div>
                </div>
                <div className="right">
                    {mailingListDetailsTable.searchInput}
                </div>
            </div>

            <div className="box">
                {mailingListDetailsTable.table}
            </div>
        </div>
    ),
);